// /account/subscription — 帳號層「雲端方案會員」入口 (user-level /v3/subscriptions):
// 可購方案、一次性免費試用、裝置加入/移除(跨方案 disable)、管理訂閱、dev 取消。
// 這些原本內嵌在 per-device 的 /account/subscription/:deviceId 頁,依業主要求移出成獨立帳號頁,
// 不再埋在某台裝置底下(per-device 頁只留該裝置的訂閱狀態/配額/帳單檢視)。
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MembershipSection } from './SubscriptionPage';
import { PhoneCamQuotaCard } from './PhoneCamQuotaCard';
import { hasBrandCap } from '../../lib/brand';

export default function MembershipPage() {
  const { t } = useTranslation();
  // 生態差異化(08 §2.1.5):brand 生態未授權 subscription:manage → 不提供。
  if (!hasBrandCap('subscription:manage')) {
    return (
      <main style={{ padding: 24 }}>
        <h1>{t('account.membershipsTitle')}</h1>
        <p>此生態未提供訂閱功能。/ Subscriptions are not available in this ecosystem.</p>
      </main>
    );
  }
  return (
    <div style={{ maxWidth: 720, display: 'flex', flexDirection: 'column', gap: 'var(--spacing-8)' }}>
      <div>
        <Link to="/account" className="text-secondary">
          ← {t('account.backToAccount')}
        </Link>
        <h1 style={{ margin: 'var(--spacing-4) 0 0', fontSize: 'var(--font-size-2xl)' }}>{t('account.membershipsTitle')}</h1>
      </div>
      <MembershipSection />
      <PhoneCamQuotaCard />
    </div>
  );
}
